import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EnteriesState } from "./enteries.reducer";

export const selectEnteriesState = createFeatureSelector<EnteriesState>('enteries');

export const selectEnteriesList = createSelector(
    selectEnteriesState,
    (state: EnteriesState) => state.enteries
)

export const selectEnteriesLoading = createSelector(
    selectEnteriesState,
    (state: EnteriesState) => state.loading
)

export const selectNbEnteriess = createSelector(
    selectEnteriesState,
    (state: EnteriesState) => state.nb
)

export const selectEnteriesError = createSelector(
    selectEnteriesState,
    (state: EnteriesState) => state.error
)

export const selectEnteryById = createSelector(
    selectEnteriesState,
    (state: EnteriesState) => state.selectedEntery
)